import { StoryTableTemplate } from './StoryTableTemplate'
import { withStoryTableTemplate } from './withStoryTableTemplate'

const ConnectedStoryTableTemplate = withStoryTableTemplate(StoryTableTemplate)
export { ConnectedStoryTableTemplate as StoryTableTemplate }
